import React from 'react';

import { EmailCampaignSignupDoubleBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpEmailCampaignSignupDoubleBlock({
  content,
  blockId,
  data,
}: AmpBlockMappingComponentProps<EmailCampaignSignupDoubleBlockData>) {
  return (
    <AmpHeroBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        // @ts-expect-error fix me
        image: data.bgImage,
        text: data.headline,
        buttonText: data.buttonTextOne,
        isEmailSignup: true,
      }}
    />
  );
}
